import component from './UiSwitcher.vue'
export default component
